// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../ToeicResourceImageSet";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        name: "",
        shortDescription: "",
        longDescription: "",
        thumbnail: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.name !== undefined)
        result.name = tsValueToJsonValueFns.string(value.name);
    if (value.shortDescription !== undefined)
        result.shortDescription = tsValueToJsonValueFns.string(value.shortDescription);
    if (value.longDescription !== undefined)
        result.longDescription = tsValueToJsonValueFns.string(value.longDescription);
    if (value.thumbnail !== undefined)
        result.thumbnail = encodeJson_1(value.thumbnail);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.name !== undefined)
        result.name = jsonValueToTsValueFns.string(value.name);
    if (value.shortDescription !== undefined)
        result.shortDescription = jsonValueToTsValueFns.string(value.shortDescription);
    if (value.longDescription !== undefined)
        result.longDescription = jsonValueToTsValueFns.string(value.longDescription);
    if (value.thumbnail !== undefined)
        result.thumbnail = decodeJson_1(value.thumbnail);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.name !== undefined) {
        const tsValue = value.name;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.shortDescription !== undefined) {
        const tsValue = value.shortDescription;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.longDescription !== undefined) {
        const tsValue = value.longDescription;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.thumbnail !== undefined) {
        const tsValue = value.thumbnail;
        result.push([4, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.name = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.shortDescription = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.longDescription = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.thumbnail = value;
    }
    return result;
}
